<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div
      class="flex justify-start divide-x-1.5 bg-white mx-3 my-5 items-center"
    >
      <div
          v-for="(menu, index) in tabs"
          :key="index"
          @click="setSelectedMenu(menu.name)"
          :class="{
      'bg-primary text-white': selectedTab === menu.name,
      }"
          class="text-sm text-center font-semibold hover:bg-primary hover:text-white cursor-pointer p-3"
      >
        {{ menu.name }}
      </div>
    </div>

    <mine
      v-if="selectedTab == 'My Training'"
      :key="mineKey"
      :showDetails="showDetails"
    ></mine>
    <team
      v-if="selectedTab == 'Team Training'"
      :key="teamKey"
      :showDetails="showDetails"
    ></team>
    <bulk-upload
      v-if="selectedTab == 'Bulk Upload'"
      :key="bulkUploadKey"
    ></bulk-upload>

    <el-drawer
      title="Training Details"
      :visible.sync="isDrawerOpen"
      :direction="direction"
      :size="isSmallScreen ? '100%' : '40%'"
    >
      <div v-html="htmlContent" class="p-2"></div>
    </el-drawer>
  </div>
</template>

<script>
import mine from "@/components/training/mine.vue";
import team from "@/components/training/team.vue";
import decryptData from "@/utils/decrypt";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "TimeOff",
  components: {
    mine,
    team,
  },
  data() {
    return {
      selectedTab: "My Training",
      teamKey: 0,
      mineKey: 1,
      filteredTabs: [],
      isDrawerOpen: false,
      direction: "rtl",
      htmlContent: null,
      isSmallScreen: false,
      tabs: [
        {
          name: "My Training",
          route: "mine",
        },
        {
          name: "Team Training",
          route: "team",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getUserType"]),
  },
  created() {
    console.log(this.$route);
    switch (this.$route.hash || this.$route.params.type) {
      case "#team":
        this.selectedTab = "Team Training";
        break;
      case "team":
        this.selectedTab = "Team Training";
        break;

      default:
        break;
    }
    if (this.getUserType === "Employee") {
      this.tabs = this.tabs.filter((tab) => tab.route !== "team");
    }
  },
  mounted() {
    // Check screen size on component mount
    this.checkScreenSize();

    // Listen for resize events to dynamically update screen size
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    // Remove resize event listener on component destroy
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    setSelectedMenu(menuName) {
      this.selectedTab = menuName;
    },
    approveTraining({ TrainingId }) {
      alert(TrainingId);
      const data = {
        TrainingId,
        Status: "Approved",
      };
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .post(
          `${this.getOrganization}/training/${this.$ApiVersion}/approve`,
          data,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode === 200) {
              this.$notify({
                title: "Success",
                message: response.data.StatusMessage,
                type: "success",
              });
              this.getTeamTrainings();
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;

            this.$notify.error({ title: "Success", message: error.message });
          }
        );
    },

    declineTraining(TrainingId) {
      TrainingId;
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/training/${this.$ApiVersion}/approve`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status == 200) {
              this.tableData = response.data.Data.filter(
                (timeoff) => timeoff.Status === "Pending"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));

              this.canceledAndDeclinedLeaves = response.data.Data.filter(
                (timeoff) => timeoff.Status !== "Pending"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
    checkScreenSize() {
      // Determine screen size based on window width
      this.isSmallScreen = window.innerWidth <= 768; // Adjust 768 according to your breakpoint
    },
    close() {
      this.$emit("close");
    },
    showDetails(data) {
      // Format currency function
      const formatCurrency = (amount) => {
        return new Intl.NumberFormat("en-KE", {
          style: "currency",
          currency: "KES",
        }).format(amount);
      };

      // Format date function
      const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
      };

      // Define status color based on the status
      const getStatusColor = (status) => {
        switch (status) {
          case "Approved":
            return { color: "text-green-600", bg: "bg-green-100" };
          case "NotStarted":
            return { color: "text-yellow-600", bg: "bg-yellow-100" };
          case "Completed":
            return { color: "text-blue-600", bg: "bg-blue-100" };
          default:
            return { color: "text-gray-600", bg: "bg-gray-100" };
        }
      };

      // Define urgency color based on the urgency level
      const getUrgencyColor = (urgency) => {
        switch (urgency) {
          case "Mild":
            return { color: "text-yellow-800", bg: "bg-yellow-200" };
          case "Trivial":
            return { color: "text-gray-800", bg: "bg-gray-200" };
          case "Urgent":
            return { color: "text-red-800", bg: "bg-red-200" };
          default:
            return { color: "text-gray-800", bg: "bg-gray-200" };
        }
      };

      const formatProgress = (progress) =>
        progress.replace(/([a-z])([A-Z])/g, "$1 $2");

      console.log(data.Members);

      // eslint-disable-next-line no-unused-vars
      const unAssignTraining = async (trainingMemberId) => {
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
          data: {
            TrainingMemberId: trainingMemberId,
          },
        };
        try {
          // Make an API call to unassign the leave type
          const response = await axios.delete(
            `${this.getOrganization}/training/${this.$ApiVersion}/unassign`,

            options
          );

          this.loading = true;
          if (response.data.StatusCode === 200) {
            this.loading = false;

            this.$notify.success({
              title: "Failure",
              message: response.data.StatusMessage,
            });
          } else {
            this.loading = false;

            this.$notify.error({
              title: "Failure",
              message: response.data.StatusMessage,
            });
          }
        } catch (error) {
          this.loading = false;

          this.$notify.error({ title: "Failure", message: error.message });
        }
      };

      let memberTable = "";

      if (data.Members && Array.isArray(data.Members) && data.Members.length) {
        memberTable = `<div  class="w-full col-span-4">

<div class="flex w-full">
  <figure class="w-full">
    <caption class="font-bold">    <span class="font-semibold">Members List</span> </caption>


  <table class="w-full">
    <thead class="text-left">
      <tr class="bg-primary text-white">
        <th class="py-2 px-4">Member Name</th>
        <th class="py-2 px-4">Progress</th>
        <th class="py-2 px-4">Assigned</th>
      </tr>
    </thead>
    <tbody class="w-full">
      ${
        data.Members && Array.isArray(data.Members) && data.Members.length
          ? data.Members.map(
              (member, index) => `
          <tr key=${index}>
            <td class="py-2 px-4">${decryptData(
              member.MemberName,
              this.$decryptionKey
            )}</td>
            <td class="py-2 px-4">${formatProgress(member.Progress)}</td>
            <td class="py-2 px-4">
              <input type="checkbox" checked onchange="unAssignTraining(${
                member.TrainingMemberId
              })" class="form-checkbox text-primaryColor focus:ring-primaryColor">
            </td>
          </tr>
        `
            ).join("")
          : `<tr><td colspan="3" class="py-4 px-4 text-gray-500">No members available</td></tr>`
      }
    </tbody>
  </table>
</figure>
</div>
</div>
`;
      }

      this.htmlContent = `
    <div class="container mx-auto px-4 py-8>
      <div class="bg-white rounded-lg shadow-md p-6">
        <h2 class="text-2xl font-bold mb-2"><span class="font-semibold">Training: </span> ${
          data.Name
        }</h2>
        <div class="grid grid-cols-2 gap-4 mb-6">
          <div>

            <p class="text-gray-600 mb-2"><span class="font-semibold">Start Date:</span> ${formatDate(
              data.StartDate
            )}</p>
            <p class="text-gray-600 mb-2"><span class="font-semibold">End Date:</span> ${formatDate(
              data.EndDate
            )}</p>
            <p class="text-gray-600 mb-2"><span class="font-semibold">Urgency:</span>
            <span class="${getUrgencyColor(data.Urgency).color} ${
        getUrgencyColor(data.Urgency).bg
      } py-1 px-2 rounded">
              ${data.Urgency}
            </span>
          </p>
            <p class="text-gray-600 mb-2"><span class="font-semibold">Source:</span> ${
              data.Source.includes("http")
                ? `<a href="${data.Source}" target="_blank" class="text-blue-600 underline">Link</a>`
                : data.Source
            }</p>
          </div>
          <div>
            <p class="text-gray-600 mb-2"><span class="font-semibold">Cost:</span> <span class="font-bold">${formatCurrency(
              data.Cost
            )}</span></p>
            <p class="text-gray-600 mb-2"><span class="font-semibold">Status:</span> <span class="${
              getStatusColor(data.Status).color
            } ${getStatusColor(data.Status).bg} py-1 px-2 rounded">${
        data.Status
      }</span></p>
          </div>

        ${memberTable}
        </div>
        <div class="border-t border-gray-300 pt-4">
          <h3 class="text-lg font-semibold mb-2">Description:</h3>
          <textarea class="w-full p-2 bg-gray-100 rounded-md border border-gray-300 resize-none h-24" disabled>${
            data.Description
          }</textarea>
        </div>

        <!-- Display approve button if status is not approved -->

       ${
         data.Status !== "Approved"
           ? `<div class='flex gap-3'>
                <button
                  @click="() => approveTraining(${data.TrainingId})"
                  class="mt-4 bg-yellow-500 text-white font-semibold py-2 px-4 rounded-md shadow-md hover:bg-yellow-600 transition duration-300"
                >
                  Approve
                </button>
                <button
                  @click="() => declineTraining(${data.TrainingId})"
                  class="mt-4 bg-red-500 text-white font-semibold py-2 px-4 rounded-md shadow-md hover:bg-red-600 transition duration-300"
                >
                  Decline
                </button>
              </div>`
           : ""
       }


      </div>
    </div>`;

      // Open the drawer
      this.isDrawerOpen = true;
    },
  },

  watch: {
    $route(to) {
      this.tabs.forEach((tab) => {
        if (tab.route == to.params.type) {
          this.selectedTab = tab.name;
        }
      });
      switch (this.selectedTab) {
        case "My Training":
          this.mineKey++;
          break;
        case "Team Training":
          this.teamKey++;
          break;
      }
    },
  },
};
</script>

<style scoped>
tr:nth-child(even) {
  background-color: #f2f2f2;
}
</style>
